import { render } from "./ScoreDistChart.vue?vue&type=template&id=55620836&ts=true"
import script from "./ScoreDistChart.vue?vue&type=script&lang=ts"
export * from "./ScoreDistChart.vue?vue&type=script&lang=ts"

import "./ScoreDistChart.vue?vue&type=style&index=0&id=55620836&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__